import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonGroup, IconButton } from '@mui/material';
import LightTooltip from 'views/components/controls/LightTooltip';
import Controls from './Controls';
import api from 'services/api';

import BlockIcon from '@mui/icons-material/Block';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


const Edit = (props) => {
    const { url } = props;

    const navigate = useNavigate();

    const redirect = () => {
        navigate(url);
    }

    return (
        <IconButton variant="contained" color="primary" onClick={redirect}>
            <EditIcon />
        </IconButton>
    );
}

const Delete = (props) => {
    const { updateList } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    async function handleConfirm() {
        setOpen(false);
        updateList();
    };

    return (
        <div>
            <IconButton variant="contained" color="primary" onClick={handleClickOpen}>
                <DeleteIcon />
            </IconButton>
            <Controls.DialogConfirm
                open={open}
                textTitle="Deseja continuar?"
                textContent="Você confirma a exclusão desse registro?"
                handleClose={handleClose}
                handleConfirm={handleConfirm}
            />
        </div>
    );
}

export default function ActionsColumn(props) {

    const { edit = true, remove = true, urlRedirect, excluido, updateList } = props;

    if (excluido) {
        return (
            <LightTooltip title="Registro Excluído">
                <IconButton variant="contained" color="primary">
                    <BlockIcon />
                </IconButton>
            </LightTooltip>
        );
    } else {
        return (
            <ButtonGroup aria-label="outlined primary button group">
                { edit ? <Edit url={urlRedirect} /> : '' }
                { remove ? <Delete updateList={updateList} /> : '' }
            </ButtonGroup>
        );
    }
}